import {ChangeDetectionStrategy, Component, computed, ElementRef, Injectable, input, signal, TemplateRef, viewChild} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {HtmlTekst, KorellertGruppertSpørreundersøkelseResultatModell, OppdaterAnalyseSpesifikasjon, SpørreskjemaId, SpørreskjemaModell, SpørreskjemaRessursClient, SpørreundersøkelseAnalyseModell, SpørreundersøkelseEnkelModell, SpørreundersøkelseId, SpørreundersøkelseRessursClient, StengForBesvarelseSpesifikasjon, TilgangsrolleMedlem, TynnSakModell, ÅpneForBesvarelseSpesifikasjon} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule} from "@ngx-translate/core";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {MatButton, MatIconButton} from "@angular/material/button";
import {C3TodeltPaiKomponent} from "web-ng2/delt/komponenter/c3-todelt-pai/c3-todelt-pai";
import {MatTooltip} from "@angular/material/tooltip";
import {SpørreundersøkelseKorellertResultatlisteKomponent} from "../spørreundersøkelse-korellert-resultatliste/spørreundersøkelse-korellert-resultatliste";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {MatDivider} from "@angular/material/divider";
import {asynkArbeidPågårSignal} from "felles-ng2/tjenester/AsynkArbeidPågårSignal";
import {TipsKomponent} from "web-ng2/delt/komponenter/tips/tips";
import {firstValueFrom, last} from "rxjs";
import {MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle} from "@angular/material/dialog";
import {SpørreundersøkelseBesvarelseSkjemaKomponent, SpørsmålsamlingSkjemaType} from "../spørreundersøkelse-besvarelse-skjema/spørreundersøkelse-besvarelse-skjema";
import {tomtSpørreskjemaModell} from "felles-ng2/modell/tommeModeller";
import {LasterDataKomponent} from "web-ng2/delt/komponenter/laster-data/laster-data";
import {InlineMeldingKomponent} from "web-ng2/delt/komponenter/inline-melding/inline-melding";
import {SubmitButtonKomponent} from "web-ng2/delt/komponenter/skjema/submit-button/submit-button";
import {VisSpinnerDirektiv} from "web-ng2/delt/direktiver/button--visSpinner/button--visSpinner";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {SpørreundersøkelseInvitasjonSkjemaKomponent} from "../spørreundersøkelse-invitasjon-skjema/spørreundersøkelse-invitasjon-skjema";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import SpørreundersøkelseBesvarelseDialogKomponent from "../../modale/spørreundersøkelse-besvarelse-dialog/spørreundersøkelse-besvarelse-dialog";
import {ZonedDateTimeSomPlainDatePipe} from "felles-ng2/pipes/ZonedDateTimeSomPlainDatePipe";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";
import {SpørreundersøkelseRedigerDialogKomponent} from "web-ng2/moduler/spørreundersøkelse/modale/spørreundersøkelse-rediger-dialog/spørreundersøkelse-rediger-dialog";
import {SpørreundersøkelseGenererAnalyseDebugDialogKomponent} from "web-ng2/moduler/spørreundersøkelse/modale/spørreundersøkelse-generer-analyse-debug-dialog/spørreundersøkelse-generer-analyse-debug-dialog";
import {SpørreundersøkelseDatatjeneste} from "felles-ng2/tjenester/datalager/SpørreundersøkelseDatatjeneste";
import {RiktekstRedigeringKomponent} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/riktekst-redigering";
import {førsteVerdiLevertFraServer} from "felles-ng2/tjenester/datalager/DataOgMeta";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";
import {NgTemplateOutlet} from "@angular/common";
import {mimetyper} from "felles-ng2/støttefunksjoner/mimetyper";
import {RessursAdresser} from "felles-ng2/tjenester/ressurser/RessursAdresser";
import {åpneINyttvindu} from "felles-ng2/støttefunksjoner/nettleser";
import {EksterneLenker} from "felles-ng2/tjenester/EksterneLenker";
import {HtmlFormatertKomponent} from "web-ng2/delt/komponenter/html-formatert/html-formatert";
import {i18n} from "felles-ng2/tjenester/i18n/Oversettelser";
import {trimTilNull} from "felles-ng2/støttefunksjoner/strenger";

const debug = initDebugger('SpørreundersøkelseListevisningKomponent');

/**
 * Viser spørreundersøkelse i listeformat
 */
@Component({
    selector: 'spoerreundersoekelse-listevisning',
    templateUrl: 'spørreundersøkelse-listevisning.html',
    styleUrl: 'spørreundersøkelse-listevisning.scss',
    host: {'data-testid': 'spørreundersøkelse'},
    imports: [
        MatMenu,
        MatIcon,
        MatMenuItem,
        TranslateModule,
        MatIconButton,
        MatMenuTrigger,
        C3TodeltPaiKomponent,
        MatTooltip,
        MatButton,
        SpørreundersøkelseKorellertResultatlisteKomponent,
        MatDivider,
        TipsKomponent,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
        SpørreundersøkelseBesvarelseSkjemaKomponent,
        MatDialogClose,
        LasterDataKomponent,
        InlineMeldingKomponent,
        SubmitButtonKomponent,
        VisSpinnerDirektiv,
        ReactiveFormsModule,
        SpørreundersøkelseInvitasjonSkjemaKomponent,
        MatFormField,
        MatLabel,
        MatSlideToggle,
        ZonedDateTimeSomPlainDatePipe,
        FormaterPlainDatePipe,
        RiktekstRedigeringKomponent,
        NgTemplateOutlet,
        HtmlFormatertKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpørreundersøkelseListevisningKomponent {

    private visSkjemaDialogTemplate = viewChild.required<TemplateRef<ElementRef>>('visSkjemaDialogTemplate');
    private slettUndersøkelseDialogTemplate = viewChild.required<TemplateRef<ElementRef>>('slettUndersoekelseDialogTemplate');
    private åpneUndersøkelseDialogTemplate = viewChild.required<TemplateRef<ElementRef>>('aapneUndersoekelseDialogTemplate');
    private stengUndersøkelseDialogTemplate = viewChild.required<TemplateRef<ElementRef>>('stengUndersoekelseDialogTemplate');

    undersoekelse = input.required<SpørreundersøkelseEnkelModell>();

    visResultater = signal(false);
    /** Korrelerte og grupperte undersøkelsesresultater, null inntil detaljer vises. */
    resultater = signal<KorellertGruppertSpørreundersøkelseResultatModell | null>(null);
    /** Saker denne undersøkelsen er registrert som saksdokument i, null inntil detaljer vises. */
    behandlinger = signal<TynnSakModell[] | null>(null);
    /** Antall saker denne undersøkelsen er registrert som saksdokument i, merk at denne er 0 inntil {@link #behandlinger} har blitt lastet. */
    antallBehandlinger = computed(() => this.behandlinger()?.length ?? 0);
    brukerKanRedigere = computed(() => this.kontekst.autentisertBruker().inneharTilgangsrolleIGruppe(TilgangsrolleMedlem.skrive, this.undersoekelse().eiendeGruppeId));
    /** Sann dersom bruker har featurevalg 'ki' aktivert, kun disse har tilgang til test av analyseprompt, se {@link genererAnalyseDebug} */
    brukerHarKiFeature = computed(() => this.kontekst.autentisertBruker().erFeatureAktivert('ki'));

    laster = asynkArbeidPågårSignal();
    /** Sann mens analyse av resultatet genereres, se {@link genererAnalyse} */
    generererAnalyse = asynkArbeidPågårSignal();
    /** Sann mens redigert analyse lagres, se {@link lagreAnalyse} */
    lagrerAnalyse = asynkArbeidPågårSignal();
    /** Sann når bruker redigerer analysen av resultatet */
    redigererAnalyse = signal(false);
    analyseSkjemakontroll = new FormControl<HtmlTekst | null>(null);
    aapneUndersoekelseSkjema = SpørreundersøkelseInvitasjonSkjemaKomponent.opprettSkjema();
    stengUndersoekelseSkjema = new FormGroup({
        informer: new FormControl(true, {nonNullable: true}),
        beskjed: new FormControl('', {nonNullable: true})
    });
    /** Skjema som benyttes i undersøkelsen, lastes av visSkjema()*/
    skjema = signal<SpørreskjemaModell>(tomtSpørreskjemaModell());
    /** Skjema som benyttes i undersøkelsen, {@link SpørsmålsamlingSkjemaType}, lastes av visSkjema()*/
    skjemaSomUndersoekelse = signal<SpørsmålsamlingSkjemaType | null>(null);
    mimeinfoPdf = mimetyper.pdf;

    private aktivDialog: MatDialogRef<any> | null = null;

    constructor(private avhengigheter: SpørreundersøkelseListevisningKomponentAvhengigheter,
                private kontekst: BrukerkontekstTilbyder,
                private navigasjon: Navigasjon,
                private ressursAdresser: RessursAdresser,
                private eksterneLenker: EksterneLenker,
                private dialog: MatDialog) {
    }

    async visSkjulResultater() {
        this.visResultater.update(vis => !vis);
        if (!this.visResultater()) return;
        this.lastBehandlinger(); //vi viser kun laster-melding for lasting av resultater
        //dersom undersøkelsen aldri har vært åpnet er det ingen resultater å hente
        if (!this.undersoekelse().erAapenForRespons && !this.undersoekelse().erAvsluttet) return;
        //dersom undersøkelsen er pågående viser vi ikke resultater
        if (this.undersoekelse().erAapenForRespons) return;

        //last resultater dersom vi ikke allerede har lastet resultater eller er i ferd med å laste dem
        if (erIkkeNil(this.resultater()) || this.laster()) return;
        await this.laster.utfør(async () => this.resultater.set(await this.avhengigheter.lastResultater(this.undersoekelse().id)));
    }

    /** Genererer analyse av resultatet, og viser denne når genereringen er ferdig */
    async genererAnalyse() {
        const generert = await this.generererAnalyse.utfør(() => this.avhengigheter.genererAnalyse(this.undersoekelse().id));
        if (generert != null) this.oppdaterAnalyseIResultater(generert.analyse);
    }

    redigerAnalyse() {
        this.analyseSkjemakontroll.setValue(this.resultater()?.analyse ?? null);
        this.redigererAnalyse.set(true);
    }

    /** Lagrer redigert analyse, tom analyse lagres som null slik at analysen fjernes og kan genereres på nytt */
    async lagreAnalyse() {
        const lagret = await this.lagrerAnalyse.utfør(() => this.avhengigheter.oppdaterAnalyse(this.undersoekelse().id, {analyse: this.analyseSkjemakontroll.value || null}));
        if (lagret == null) return; //feilmelding er vist, bruker kan forsøke å lagre på nytt
        this.oppdaterAnalyseIResultater(lagret.analyse);
        this.redigererAnalyse.set(false);
    }

    avbrytRedigeringAvAnalyse() {
        this.redigererAnalyse.set(false);
    }

    async visSkjema() {
        this.dialog.open(this.visSkjemaDialogTemplate(), {
            height: '75vh', //.mat-mdc-dialog-content er def med 'max-height: 65vh', så mer enn 75vh vil ikke fungere uten at .mat-mdc-dialog-content overstyres
            width: '80vw',
            maxWidth: '1200px'
        });
        this.skjema.set(await this.avhengigheter.lastSkjema(this.undersoekelse().skjemaId));
        this.skjemaSomUndersoekelse.set(this.spørreskjemaSomSpørsmålsamlingSkjema(this.skjema()));
    }

    aapneResultatrapport() {
        åpneINyttvindu(this.ressursAdresser.spørreundersøkelsePdfRapportUrl(this.undersoekelse()));
    }

    aapneHjelpetekstForBehandleSpoerreundersoekelse() {
        åpneINyttvindu(this.eksterneLenker.hjelpesider.behandleSpørreundersøkelseISak);
    }

    gaaTilSak(sak: TynnSakModell) {
        this.aktivDialog?.close(); //tilfelle vi blir kalt fra slett-dialogen
        this.navigasjon.gåTilMøteOgSak(sak.moete.id, sak.id);
    }

    async besvar() {
        const besvart = await firstValueFrom(SpørreundersøkelseBesvarelseDialogKomponent.vis(this.dialog, this.undersoekelse().id, this.undersoekelse().kallendeBrukersRespondentId).beforeClosed());
        if (besvart) this.avhengigheter.relastUndersøkelse(this.undersoekelse().id);
    }

    aapne() {
        this.aktivDialog = this.dialog.open(this.åpneUndersøkelseDialogTemplate(), {maxWidth: '600px', minHeight: '390px'});
    }

    async utfoerAapne() {
        const skjemaverdier = this.aapneUndersoekelseSkjema.value;
        const spesifikasjon: ÅpneForBesvarelseSpesifikasjon = {
            antallDagerTilStenging: skjemaverdier.varighet!,
            informerRespondenter: skjemaverdier.sendInvitasjon!,
            beskjed: trimTilNull(skjemaverdier.beskjed)
        }
        await this.laster.utfør(async () => this.avhengigheter.åpneForBesvarelse(this.undersoekelse().id, spesifikasjon));
        this.aktivDialog?.close();
    }

    steng() {
        this.aktivDialog = this.dialog.open(this.stengUndersøkelseDialogTemplate(), {maxWidth: '600px', minHeight: '370px'});
    }

    async utfoerSteng() {
        const skjemaverdier = this.stengUndersoekelseSkjema.value;
        const spesifikasjon: StengForBesvarelseSpesifikasjon = {
            informerRespondenter: skjemaverdier.informer!,
            beskjed: trimTilNull(skjemaverdier.beskjed)
        }
        await this.laster.utfør(async () => this.avhengigheter.stengForBesvarelse(this.undersoekelse().id, spesifikasjon));
        this.aktivDialog?.close();
    }

    rediger() {
        SpørreundersøkelseRedigerDialogKomponent.vis(this.dialog, this.undersoekelse().id);
    }

    genererAnalyseDebug() {
        SpørreundersøkelseGenererAnalyseDebugDialogKomponent.vis(this.dialog, this.undersoekelse().id);
    }

    async slett() {
        this.aktivDialog = this.dialog.open(this.slettUndersøkelseDialogTemplate(), {maxWidth: '600px'});
        await this.laster.utfør(async () => this.lastBehandlinger());
    }

    async utfoerSlett() {
        await this.laster.utfør(async () => this.avhengigheter.slettUndersøkelse(this.undersoekelse().id));
        this.aktivDialog?.close();
    }

    // private hjelpemetoder

    private async lastBehandlinger() {
        if (erIkkeNil(this.behandlinger())) return;
        this.behandlinger.set(await this.avhengigheter.lastBehandlinger(this.undersoekelse().id));
    }

    private spørreskjemaSomSpørsmålsamlingSkjema(skjema: SpørreskjemaModell): SpørsmålsamlingSkjemaType | null {
        if (erNil(skjema)) return null;
        return SpørreundersøkelseBesvarelseSkjemaKomponent.opprettIkkeRedigerbartSkjema(skjema);
    }

    protected readonly last = last;

    private oppdaterAnalyseIResultater(analyse: HtmlTekst | null) {
        this.resultater.update(resultater => resultater == null ? null : {...resultater, analyse});
    }
}

@Injectable()
export class SpørreundersøkelseListevisningKomponentAvhengigheter {

    constructor(private spørreundersøkelseRessurs: SpørreundersøkelseRessursClient,
                private spørreskjemaRessurs: SpørreskjemaRessursClient,
                private spørreundersøkelseDatatjeneste: SpørreundersøkelseDatatjeneste) {
    }

    /** Laster angitt skjema, ved feil vises feilmelding og {@link tomtSpørreskjemaModell} returneres */
    lastSkjema(id: SpørreskjemaId): Promise<SpørreskjemaModell> {
        return this.spørreskjemaRessurs.hent(id)
          .somPromiseVisMeldingVedFeilOgReturnerVerdi(
            (feil, oversettelser) => oversettelser.oversett(i18n('Kunne ikke hente resultater fra spørreundersøkelsen')),
            tomtSpørreskjemaModell());
    }

    /** Laster resultater for angitt undersøkelse, ved feil vises feilmelding og null returneres */
    lastResultater(id: SpørreundersøkelseId): Promise<KorellertGruppertSpørreundersøkelseResultatModell | null> {
        return this.spørreundersøkelseRessurs.hentKorrelertGruppertResultat(id)
          .somPromiseVisMeldingVedFeilOgReturnerVerdi(
            (feil, oversettelser) => oversettelser.oversett(i18n('Kunne ikke hente resultater fra spørreundersøkelsen')),
            null);
    }

    /** Laster saker der angitt undersøkelse behandles, ved feil vises feilmelding og tom liste returneres */
    lastBehandlinger(id: SpørreundersøkelseId): Promise<TynnSakModell[]> {
        return this.spørreundersøkelseRessurs.hentBehandlingerISak(id)
          .somPromiseVisMeldingVedFeilOgReturnerVerdi(
            (feil, oversettelser) => oversettelser.oversett(i18n('Kunne ikke hente behandlinger av spørreundersøkelsen')),
            []);
    }

    /** Genererer analyse av resultatet for angitt undersøkelse, ved feil vises feilmelding og null returneres */
    genererAnalyse(id: SpørreundersøkelseId): Promise<SpørreundersøkelseAnalyseModell | null> {
        return this.spørreundersøkelseRessurs.genererAnalyse(id)
          .somPromiseVisMeldingVedFeilOgReturnerVerdi(i18n('Kunne ikke generere analyse av resultatet'), null);
    }

    /** Oppdaterer analysen av resultatet for angitt undersøkelse, ved feil vises feilmelding og null returneres */
    oppdaterAnalyse(id: SpørreundersøkelseId, spesifikasjon: OppdaterAnalyseSpesifikasjon): Promise<SpørreundersøkelseAnalyseModell | null> {
        return this.spørreundersøkelseRessurs.oppdaterAnalyse(id, spesifikasjon)
          .somPromiseVisMeldingVedFeilOgReturnerVerdi(i18n('Kunne ikke lagre analysen av resultatet'), null);
    }

    async åpneForBesvarelse(id: SpørreundersøkelseId, spesifikasjon: ÅpneForBesvarelseSpesifikasjon): Promise<void> {
        await this.spørreundersøkelseDatatjeneste.åpneForBesvarelse(id, spesifikasjon);
    }

    async stengForBesvarelse(id: SpørreundersøkelseId, spesifikasjon: StengForBesvarelseSpesifikasjon): Promise<void> {
        await this.spørreundersøkelseDatatjeneste.stengForBesvarelse(id, spesifikasjon);
    }

    async relastUndersøkelse(id: SpørreundersøkelseId): Promise<void> {
        await førsteVerdiLevertFraServer(this.spørreundersøkelseDatatjeneste.hentMedMeta(id));
    }

    async slettUndersøkelse(id: SpørreundersøkelseId): Promise<void> {
        await this.spørreundersøkelseDatatjeneste.slett(id);
    }
}
